import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'Currency';
const ENDPOINT = `/currencies/`;

@Injectable({
    providedIn: 'root'
})
export class CurrencyService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
